import React, { useState, useEffect } from "react";
import { FaClock, FaSyncAlt } from "react-icons/fa";

export default function SuperadminHeader({ user, systemHealth, onRefresh, isRefreshing }) {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const formatDate = (date) => {
    return date.toLocaleDateString("es-MX", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString("es-MX", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  const isHealthy = !systemHealth?.activeAlertsCount || systemHealth.activeAlertsCount === 0;

  return (
    <div className="sad-executive-header">
      <div className="page-header-row flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="page-title-wrapper sad-executive-heading">
          <p className="page-subtitle">
            Bienvenido, <strong>{user?.fullName || user?.username || "Super Administrador"}</strong> · Visión integral y observabilidad del sistema en tiempo real.
          </p>
        </div>

        <div className="flex items-center gap-3 flex-wrap sad-executive-actions">
          {/* Badge de operatividad */}
          <span
            className={`sad-executive-health inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold ${
              isHealthy
                ? "bg-emerald-50 text-emerald-700 border border-emerald-200"
                : "bg-amber-50 text-amber-700 border border-amber-200"
            }`}
            role="status"
            aria-live="polite"
            aria-label={isHealthy ? "Plataforma 100% Operativa" : `${systemHealth.activeAlertsCount} Alertas`}
          >
            <span
              className={`w-2 h-2 rounded-full ${isHealthy ? "bg-emerald-500" : "bg-amber-500 animate-ping"}`}
              aria-hidden="true"
            />
            <span className="sad-executive-health-label">
              {isHealthy ? "Plataforma 100% Operativa" : `${systemHealth.activeAlertsCount} Alertas`}
            </span>
            <span className="sad-executive-health-label-mobile">
              {isHealthy ? "Operativa" : `${systemHealth.activeAlertsCount} alertas`}
            </span>
          </span>

          {/* Reloj en vivo */}
          <div className="sad-executive-clock hidden sm:flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-200 rounded-lg text-xs font-medium text-gray-600 shadow-sm">
            <FaClock className="text-gray-400" />
            <span>{formatDate(currentTime)} · <strong>{formatTime(currentTime)}</strong></span>
          </div>

          {/* Botón de refresco */}
          <button
            type="button"
            onClick={onRefresh}
            disabled={isRefreshing}
            className="sad-executive-refresh flex items-center gap-2 px-3.5 py-1.5 text-xs font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 shadow-sm transition active:scale-[0.98] disabled:opacity-60"
            aria-label="Sincronizar métricas del sistema"
            title="Sincronizar métricas del sistema"
          >
            <FaSyncAlt
              className={`text-xs ${isRefreshing ? "animate-spin text-primary" : "text-gray-500"}`}
              aria-hidden="true"
            />
            <span className="sad-executive-refresh-label">
              {isRefreshing ? "Sincronizando..." : "Sincronizar"}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
